<template>
  <div class="col-12 table-responsive">
    <table class="table">
      <thead>
        <slot name="columns">
          <tr>
            <th v-for="column in columns" :key="column">{{ column }}</th>
          </tr>
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index" >
          <slot :row="item">
            <td v-for="column in columns" :key="column">
              <!-- TD -->

              <input
                v-if="column != 'TYPE' && ( column == 'NUMBER' || column == 'SEAL1' || column == 'SEAL2' || column == 'SEAL3')"
                type="text"
                :id="column + '-' + index"
                maxlength="20"
                v-model="data[index][column]"
                class="w-100 ft-10"
              />

              <input
                v-else-if="column != 'TYPE' && column != 'NUMBER' && column != 'NET_WEIGHT'"
                type="number"
                maxlength="20"
                :id="column + '-' + index"
                v-model="data[index][column]"
                class="w-100 ft-10"
                step="any"
              />

              <input v-else-if="column != 'TYPE' && column != 'NUMBER' && column == 'NET_WEIGHT'" type="number" @change="emitNetWeight()" class="w-100 ft-10" v-model="data[index][column]"/>
              
              <select
              v-else-if="column == 'TYPE'"
                name="col"
                :id="column + '-' + index"
                v-model="data[index][column]"
                class="w-100 ft-14"
              >
                <option
                  v-for="(tipo, index) in tiposContainers"
                  :key="index"
                  :value="tipo['CODE']"
                >
                  {{ tipo["CODE"] }}
                </option>
              </select>

              <!-- TD -->
            </td>
            <td>
              <a href="#" @click.prevent="deleteContainer(index)">
                <i style="color:red;" class="fa fa-times"></i>
              </a>
            </td>
          </slot>
        </tr>
        <tr>
          <td v-for="(column, index) in columns" :key="index">
            
          </td>
          <td>
            <a href="#" @click.prevent="createContainer"
              ><i class="fa fa-plus"></i></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  name: "h-table-container-webdraft",
  props: {
    columns: Array,
    data: Array,
    loading: String,
    tiposContainers: Array,
    deleted: Array,
  },
  data() {
    return {
      processoSelecionado: "",
      novoContainer: {
        ID: "",
        TYPE: "",
        NUMBER: "",
        NET_WEIGHT: "",
        SEAL1: "",
        SEAL2: "",
        SEAL3: "",
        TARA: "",
        GROSSWEIGHT: "",
        CBM: "",
        VOLUMES: "",
        NOVO: ""
      },
    };
  },
  methods: {
    createContainer() {
      this.data.push({
        ID: this.novoContainer.ID,
        TYPE: this.novoContainer.TYPE,
        NUMBER: this.novoContainer.NUMBER,
        NET_WEIGHT: this.novoContainer.NET_WEIGHT,
        SEAL1: this.novoContainer.SEAL1,
        SEAL2: this.novoContainer.SEAL2,
        SEAL3: this.novoContainer.SEAL3,
        TARA: this.novoContainer.TARA,
        GROSSWEIGHT: this.novoContainer.GROSSWEIGHT,
        CBM: this.novoContainer.CBM,
        VOLUMES: this.novoContainer.VOLUMES,
      });
      this.novoContainer = {
        ID: "",
        TYPE: "",
        NUMBER: "",
        NET_WEIGHT: "",
        SEAL1: "",
        SEAL2: "",
        SEAL3: "",
        TARA: "",
        GROSSWEIGHT: "",
        CBM: "",
        VOLUMES: "",
      }
    },
    deleteContainer(index) {
      this.deleted.push(this.data[index]);
      console.log(this.deleted);
      this.data.splice(index, 1);
    },
    createEditar(e) {
      let data = {
        processo: e.target.id,
        last_status: e.target.getAttribute("name"),
      };
      if (data.processo != "" || data.processo != null) {
        this.$emit("click", data);
      }
    },
    emitNetWeight(){
      this.$emit('input-modified', this.inputValue);
    }
  },
};
</script>
<style>
p,span,input,textarea,td,pre{font-size:14px;}

.nc-icon-ml-30 {
  margin-left: 30%;
}
.p14 {
  font-size: 12px;
  margin-bottom: 0px;
}
td {
  max-width: 150px;
  padding: 5px 8px 5px 15px !important;
  vertical-align: top !important;
}
.icon-td {
  width: 20px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}
</style>
